import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({
  title = "DayShift MMA - UFC Fantasy League Platform",
  description = "Join the ultimate UFC fantasy league platform. Create leagues with friends, compete globally, build your fighter lineup, and dominate the octagon. Free to play!",
  keywords = "UFC fantasy, MMA fantasy league, UFC picks, fantasy fighting, UFC competition, MMA predictions, fantasy sports, UFC lineup",
  image = "/logo-gold.png",
  url = window.location.href,
  type = "website",
  author = "DayShift MMA",
  twitterHandle = "@DayShiftMMA",
  noindex = false,
  canonicalUrl,
  structuredData,
}) => {
  const siteUrl =
    process.env.REACT_APP_SITE_URL || "https://dayshiftsports.com";
  const fullImageUrl = image.startsWith("http") ? image : `${siteUrl}${image}`;
  const fullUrl = url.startsWith("http") ? url : `${siteUrl}${url}`;
  const canonical = canonicalUrl || fullUrl;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <link rel="canonical" href={canonical} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:site_name" content="DayShift MMA" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={fullUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={fullImageUrl} />
      <meta property="twitter:creator" content={twitterHandle} />
      <meta property="twitter:site" content={twitterHandle} />

      {/* Structured Data */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
